import state from './role.state'
import mutations from './role.mutations'
import actions from './role.actions'
import getters from './role.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



//////////////////
// WEBPACK FOOTER
// ./state/role/role.module.js
// module id = null
// module chunks = 